<template>
  <div :class="['splash-wrapper', { ja: !isZH }]">
    <div>
      <img id="home-logo" class="logo" :src="require('../assets/fenrir_logo.svg')" />
      <div class="cooperate">
        <div class="cooperate-title">
          <img :src="require('../assets/line.svg')" />
          <p>{{ pr.cooperate.title }}</p>
          <img :src="require('../assets/line.svg')" />
        </div>
        <div class="cooperate-content">
          <div class="cooperate-ifs">
            <div class="img-box">
              <img :src="getImageUrl(pr.cooperate.ifs.logo)" alt="ifs-logo" />
            </div>
            <div>
              <p>{{ pr.cooperate.ifs.name }}</p>
              <div v-if="pr.cooperate.ifs.tags && pr.cooperate.ifs.tags.length" class="tags">
                <span v-for="tag in pr.cooperate.ifs.tags" :key="tag" class="tag">{{ tag }}</span>
              </div>
            </div>
          </div>
          <div class="cooperate-deep-robot">
            <div class="img-box">
              <img :src="getImageUrl(pr.cooperate.deep_robot.logo)" alt="deep-robot-logo" />
            </div>
            <div>
              <p>{{ pr.cooperate.deep_robot.name }}</p>
              <div v-if="pr.cooperate.deep_robot.tags && pr.cooperate.deep_robot.tags.length" class="tags">
                <span v-for="tag in pr.cooperate.deep_robot.tags" :key="tag" class="tag robot-tag">{{ tag }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="title pc" v-html="titlePC"></p>
      <p class="title sp" v-html="titleSP"></p>
      <p class="description pc">{{ description1PC }}</p>
      <p class="description sp">{{ description1SP }}</p>
      <p v-if="description2PC" class="description description2 pc">{{ description2PC }}</p>
      <p v-if="description2SP" class="description description2 sp">{{ description2SP }}</p>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue';
import { LOCALES } from '@/constants/constants';
import usePageResource from '@/composables/usePageResource';
import useRenderData from '@/composables/useRenderData';

export default {
  name: 'Splash',
  computed: {
    isZH() {
      return this.locale === LOCALES.ZH;
    },
    titlePC() {
      return this.pr.title_pc.replace(/\n/gm, '<br/>');
    },
    titleSP() {
      return this.pr.title_sp.replace(/\n/gm, '<br/>');
    },
    description1PC() {
      return this.pr.description1_pc;
    },
    description1SP() {
      return this.pr.description1_sp;
    },
    description2PC() {
      return this.pr.description2_pc;
    },
    description2SP() {
      return this.pr.description2_sp;
    },
  },
  setup() {
    const { pr } = usePageResource('splash');
    const { getImageUrl } = useRenderData('splash');
    const locale = inject('locale');
    return {
      pr,
      getImageUrl,
      locale,
    };
  },
  // mounted() {
  //   if (/mobi|tablet|ipad|iphone|android/.test(navigator.userAgent.toLowerCase())) {
  //     const splash = $('.splash-wrapper');
  //     const viewportHeight = window.innerHeight;
  //     splash.css({ height: viewportHeight });
  //   }
  // },
};
</script>

<style scoped lang="scss">
  .splash-wrapper {
    margin-top: 120px;
    box-sizing: border-box;
    padding: 0 64px 9px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    text-align: center;
    color: #464849;
  }

  .logo {
    margin-right: 4px;
    width: 137.7px;
    opacity: 0;
    animation: 1s cubic-bezier(0.165, 0.84, 0.44, 1) 200ms 1 forwards fade-in;
  }

  .cooperate {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    margin-top: 120px;
    opacity: 0;
    animation: 800ms cubic-bezier(0.165, 0.84, 0.44, 1) 500ms 1 forwards slide-up-fading;

    .cooperate-title {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 16px;

      p {
        color: #A7AEB1;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.15px;
        flex-shrink: 0;
      }
    }

    .cooperate-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .cooperate-deep-robot,
      .cooperate-ifs {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 24px;
        padding: 24px 0;

        .img-box {
          img {
            width: 250px;
            height: 65px;
            object-fit: cover;
            object-position: center;
          }
        }

        p {
          color: #222;
          font-size: 20px;
          font-weight: 700;
          letter-spacing: 0.8px;
          text-align: left;
          line-height: 29px;
        }

        .tags {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          margin-top: 8px;
          flex-wrap: wrap;

          .tag {
            background: #F1F3F4;
            color: #8427E2;
            font-size: 12px;
            line-height: 18px;
            padding: 5px 10px;
            font-weight: 500;
            border-radius: 4px;
          }

          .robot-tag {
            color: #666666;
          }
        }
      }

      .cooperate-deep-robot {
        .img-box {
          img {
            height: 48px;
          }
        }
      }
    }
  }

  .title {
    margin-top: 64px;
    margin-bottom: 34px;
    opacity: 0;
    line-height: 42px;
    font-size: 30px;
    font-weight: bold;
    animation: 800ms cubic-bezier(0.165, 0.84, 0.44, 1) 500ms 1 forwards slide-up-fading;
    color: #222222;
  }

  .description {
    flex: 1 1 auto;
    opacity: 0;
    font-size: 18px;
    line-height: 35px;
    white-space: pre-line;
    animation: 800ms cubic-bezier(0.165, 0.84, 0.44, 1) 800ms 1 forwards slide-up-fading;
    color: #222;
  }

  .ja {
    .logo {
      margin-right: 8px;
    }

    .title {
      margin-top: 64px;
      margin-bottom: 32px;
      line-height: 35px;
    }
  }

  @media only screen and (max-width: 1024px) {
    .cooperate {
      border-bottom: 1px solid #E4E9EB;
      .cooperate-content {
        .cooperate-ifs,
        .cooperate-deep-robot {
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr;
          justify-items: center;
          gap: 24px;
          padding: 32px 0;

          p {
            text-align: center;
          }

          .tags {
            justify-content: center;
          }
        }
      }
    }

    .title {
      font-size: 3.5vw;
      margin-top: 120px;
    }

    .description {
      font-size: 1.8vw;
    }
  }

  .description2 {
    margin-top: 16px;
  }

  @media only screen and (min-width: 769px) {
    .sp {
      &.title, &.description {
        margin: 0;
        height: 0;
        // visibility: hidden;
        display: none;
      }
    }
  }

  @media only screen and (max-width: 768px) {
      .splash-wrapper {
        margin-top: 80px;
        padding-bottom: 9px;
        padding-right: 24px;
        padding-left: 24px;
      }

      .logo {
        margin-right: 0;
        width: 68.85px;
        height: 96px;
      }

      .cooperate {
        margin-top: 64px;
        gap: 16px;

        .cooperate-title {
          width: 100%;

          img {
            flex: 1 1 0;
            min-width: 0;
            height: 1px;
            object-fit: cover;
          }
        }

        .cooperate-content {
          .cooperate-ifs,
          .cooperate-deep-robot {
            p {
              font-size: 16px;
            }

            .tags {
              .tag {
                padding-left: 8.5px;
                padding-right: 8.5px;
              }
            }
          }
        }
      }

      .title {
        margin-top: 40px;
        margin-bottom: 24px;
        font-size: 22px;
        line-height: 30px;
        letter-spacing: 0.5px;
      }

      .description {
        font-size: 14px;
        line-height: 30px;
      }

      .description2 {
        margin-top: 12px;
      }

      .pc {
        &.title, &.description {
          margin: 0;
          height: 0;
          // visibility: hidden;
          display: none;
        }
      }

      .ja {
        .logo {
          margin-right: 0;
        }

        .title {
            margin-top: 39px;
            margin-bottom: 26px;
        }
      }
    }

  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes slide-up-fading {
    0% {
      opacity: 0;
      transform: translateY(100px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slide-down-fading {
    0% {
      opacity: 0;
      transform: translateY(-8px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>
